export const ZEBRA_ROW_BACKGROUND = "#eef1f5";

// Realce da linha sob o cursor — aplicado a QUALQUER linha (branca, zebra ou com formatação
// condicional), com contraste suficiente para se ver por cima de todas. Entra sempre por um
// pseudo-classe `&:hover`, que ganha em especificidade ao fundo base da linha.
export const ROW_HOVER_BACKGROUND = "#d4e4f5";

export const dashboardTableSx = {
    "& .MuiTableCell-root": { fontSize: "1rem" },
};
